<onyx-modal
  variant="center"
  heading="{{ `${I18N}.wantBlock` | translate }} 
  {{ contractor.companyProfile.displayName }}?"
  [close$]="close$"
  (keydown.enter)="submit()"
  (closeModal)="dialogRef.close($event)"
>
  <div class="container">
    <onyx-message intent="warning">
      <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

      <p [innerHTML]="`${I18N}.blockInformation` | translate"></p>
    </onyx-message>

    <form [formGroup]="form" [onyxAutoFocus]="true">
      @let controls = form.controls;
      <onyx-tabs
        [formControl]="controls.reason"
        [label]="`${I18N}.blockReason`"
        [tabs]="contractorBlockReason$ | async"
        [size]="40"
      ></onyx-tabs>

      <onyx-text-field
        [formControl]="controls.reasonDescription"
        [label]="`${I18N}.blockComment`"
      ></onyx-text-field>
    </form>
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next(false)">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      color="red"
      [spinner]="loading()"
      (click)="!loading() ? submit() : null"
    >
      {{ 'labels.block' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
